import React from "react";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatInTimeZone } from "date-fns-tz";
import { useAlterarVenda } from "./hooks";
import HeaderReport from "../../../components/header/report";
import { CardDadosVenda } from "./_components/card-dados-venda";
import { TableItensVenda } from "./_components/table-itens-venda";
import { ResumoFinanceiroVenda } from "./_components/resumo-financeiro-venda";
import { TableParcelasVenda } from "./_components/table-parcelas-venda";
import ModalMain from "../../../components/modal";
import { RegisterClientProvider } from "../../../components/register/register-cliente/context";
import { MainRegisterClient } from "../../register/register-cliente";
import MessageDialog from "../../../components/ui/dialog/MessageDialog";
import ModalAlteracaoVenda from "./_components/modal-alteracao-venda";
import ModalRefazerParcelas from "./_components/ModalRefazerParcelas";

export default function AlterarVenda({ idVendaProp, onAlteracao }) {
	const { id: idParam } = useParams();
	const id = idVendaProp || idParam;
	const {
		venda,
		itens,
		parcelas,
		complementos,
		loading,
		saving,
		pendingClient,
		isConfirmOpen,
		onSelectClient,
		handleConfirmClient,
		handleCancelClient,
		isRefazerOpen,
		setIsRefazerOpen,
		handleAbrirAlteracaoGeral,
		handleAlteracaoGeralSalva,
		isParcelasOpen,
		setIsParcelasOpen,
		handleSaveParcelas,
	} = useAlterarVenda(id, onAlteracao);

	const identModalSelectClient = "modalSelectClientVenda";


	if (loading) {
		return <div className="p-10 text-center font-bold text-gray-500">Buscando dados no Servidor...</div>;
	}

	return (
		<div className={`${idVendaProp ? "h-full overflow-y-auto" : "mt-page"} w-full bg-white px-2 md:px-4 pt-6 pb-12`}>
			<ToastContainer />

			<header className="flex flex-col bg-white p-4 md:p-6 rounded-[24px] shadow-md border border-gray-100 mb-6 z-10">
				<div className="flex justify-between items-start mb-6">
					<HeaderReport title="Alteração de Venda" subTitle={`Venda #${venda?.id_venda || id}`} />
				</div>

				{/* Dados da Venda e do Cliente inseridos dentro do bloco do Header (com sombreamento) */}
				<CardDadosVenda venda={venda} />
			</header>

			{/* CORPO DO RELATÓRIO (Tabelas) */}
			<div className="w-full space-y-6">
				{/* Card de Produtos */}
				<div className="bg-white p-4 md:p-6 rounded-[24px] shadow-md border border-gray-100 z-10">
					<TableItensVenda 
						itens={itens} 
						complementos={complementos} 
						onAlterar={handleAbrirAlteracaoGeral}
					/>
				</div>

				{/* Card de Parcelas */}
				<div className="bg-white p-4 md:p-6 rounded-[24px] shadow-md border border-gray-100 z-10">
					<TableParcelasVenda
						parcelas={parcelas}
						onRefazer={() => setIsParcelasOpen(true)}
					/>
				</div>

				{/* Card de Resumo Financeiro */}
				<div className="bg-white p-4 md:p-6 rounded-[24px] shadow-md border border-gray-100 z-10">
					<ResumoFinanceiroVenda venda={venda} />
				</div>
			</div>

			{/* Modal de Seleção de Cliente */}
			<ModalMain
				ident={identModalSelectClient}
				className="react-modal-content-base w-full max-w-[1250px] h-[95%] bg-white p-4 relative m-10"
			>
				<RegisterClientProvider>
					<MainRegisterClient isSelector={true} onSelectClient={onSelectClient} />
				</RegisterClientProvider>
			</ModalMain>

			{/* Modal de Confirmação para Alteração do Cliente */}
			<MessageDialog
				open={isConfirmOpen}
				title="Confirmar Alteração de Cliente"
				description={`Deseja realmente alterar o cliente da venda ${venda?.id_venda || ""} de '${venda?.nome || "Consumidor Final"}' para '${pendingClient?.nome || ""}'?`}
				variant="question"
				buttons="confirmCancel"
				onConfirm={handleConfirmClient}
				onCancel={handleCancelClient}
				onClose={handleCancelClient}
			/>

			{/* Modal de Alteração Geral (Produtos e Parcelas) */}
			<ModalAlteracaoVenda
				isOpen={isRefazerOpen}
				onClose={() => setIsRefazerOpen(false)}
				venda={venda}
				originalItens={itens}
				originalComplementos={complementos}
				originalParcelas={parcelas}
				onSaved={handleAlteracaoGeralSalva}
			/>

			{/* Refazer Parcelas isolado — fluxo já pronto, não passa pela Alteração Geral */}
			<ModalRefazerParcelas
				isOpen={isParcelasOpen}
				onClose={() => setIsParcelasOpen(false)}
				venda={venda}
				originalParcelas={parcelas}
				onSave={handleSaveParcelas}
				saving={saving}
			/>
		</div>
	);
}
